export default __webpack_public_path__ + "static/media/asian-smile-3672997_1920.b761d137.jpg";